'use client'

// @ts-strict-ignore
import { FC, useState } from 'react'

import { NpiRequestModal } from '@/features/product/CreatePrereservation/ui/NpiRequestModal/NpiRequestModal'

import { TProduct } from '@/shared/types/product-types'
import { Button, ButtonProps, Modal } from '@/shared/ui'

import styles from './NpiProductRequestButton.module.scss'

export type NpiProductRequestButtonProps = ButtonProps & {
	$modalContentData?: Partial<TProduct>
}

export const NpiProductRequestButton: FC<NpiProductRequestButtonProps> = ({
	children,
	$modalContentData,
	onClick,
	...props
}) => {
	const [isModalVisible, setIsModalVisible] = useState(false)

	const handleClose = () => setIsModalVisible(false)

	const handleButtonClick = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation()
		onClick?.(e)
		setIsModalVisible(true)
	}

	return (
		<>
			<Button
				{...props}
				size={'M'}
				className={`npi-button`}
				style={{ background: `#7856FE`, color: `#fff`, border: `none` }}
				onClick={handleButtonClick}>
				{children}
			</Button>
			<Modal
				isOpen={isModalVisible}
				onClose={handleClose}
				contentClassName={styles.modalContent}
				withoutCloseAnimation={false}>
				{$modalContentData && <NpiRequestModal {...$modalContentData} onCancel={handleClose} onOk={handleClose} />}
			</Modal>
		</>
	)
}
